/**
     * SystemStateChanged.contract.ts — Event Contract System™ (generation v1).
     * Legacy-world state changed. The legacy bridge mirrors window CustomEvents (nomad:occ-saved, nomad:data-changed) onto the bus with a reason discriminator; extra detail fields pass through.
     */

    import type { EventContract } from '../EventContractRegistry';

    export const SystemStateChangedContract: EventContract = {
      name: 'SystemStateChanged',
      version: 1,
      description: "Legacy-world state changed. The legacy bridge mirrors window CustomEvents (nomad:occ-saved, nomad:data-changed) onto the bus with a reason discriminator; extra detail fields pass through.",
      publishers: ["legacy-bridge"],
      subscribers: ["sidebar","home"],
      fields: [
        { name: 'reason', type: 'string', required: true, description: "Change discriminator: occ-saved | data-changed" },
    { name: 'legacyEvent', type: 'string', required: true, description: "Originating window CustomEvent name" },
    { name: 'domain', type: 'string', required: false, description: "For data-changed: execution | sessions | persona | memory" },
      ],
      allowExtraFields: true,
      timestampPolicy: "Bridge forward time (nowFn()) when the window event is mirrored.",
      stability: 'stable',
      deprecated: false,
      example: {"reason":"data-changed","legacyEvent":"nomad:data-changed","domain":"sessions"},
    };
    